import { Routes, Route } from "react-router-dom";
import './main.css'
import LandingPage from "./pages/LandingPage/LandingPage";
import AboutPage from "./pages/AboutPage/AboutPage";

const Main = () => {
    return (
      <Routes>
        <Route path="/" element = {<LandingPage/>}/>
        <Route path="/about" element={<AboutPage/>}/>
      </Routes>
    );
}

export default Main;